import { giphyBlack, giphyDarkestGrey, giphyLightGrey } from '@giphy/js-brand'
import styled from 'styled-components'
import { BORDER_RADIUS_LARGE, BORDER_RADIUS_SMALL } from '../constants'

export const WrapperBlock = styled.div`
    align-items: center;
    display: flex;
    flex-direction: column;
    justify-content: center;
    min-height: calc(100vh - 70px);
    width: 100%;
`

export const ContainerBlock = styled.div`
    background: ${giphyBlack};
    border-radius: ${BORDER_RADIUS_LARGE}px;
    box-shadow: 0 11px 30px rgba(0, 0, 0, 0.5);
    display: flex;
    font-size: 17px;
    margin: 40px auto 80px;
    min-height: 500px;
    position: relative;
    width: 100%;
`

export const SplitBlock = styled.div`
    border-radius: inherit;
    display: flex;
    width: 100%;

    > div {
        padding: 50px 30px 30px;
        width: 100%;

        &:last-child {
            background: ${giphyDarkestGrey};
            border-radius: inherit;
        }
    }
`

export const ColumnBlock = styled.div`
    display: flex;
    flex-direction: column;

    > div:first-child {
        height: 100%;
        margin-bottom: 30px;
    }
`

export const WelcomeBlock = styled.div`
    background: rgba(236, 236, 236, 0.1);
    border-radius: ${BORDER_RADIUS_SMALL}px;
    font-size: 15px;
    padding: 30px 40px;

    p:last-child,
    input:last-child {
        margin-bottom: 0;
    }
`

export const OverlayBlock = styled.div`
    height: 100%;
    left: 0;
    position: absolute;
    top: 0;
    width: 100%;
`

export const StickerBlock = styled.div`
    background-color: #000;
    background-image: linear-gradient(45deg, #0e0e0e 25%, transparent 25%, transparent 75%, #0e0e0e 75%),
        linear-gradient(45deg, #0e0e0e 25%, transparent 25%, transparent 75%, #0e0e0e 75%);
    background-size: 24px 24px;
    background-position: 0 0, 12px 12px;
`

export const GridBlock = styled.div<{ columns: number }>`
    display: grid;
    grid-template-columns: repeat(${({ columns }) => columns}, 1fr);
    gap: 10px;
`

export const UploadFieldBlock = styled.div`
    color: ${giphyLightGrey};

    input {
        border-radius: ${BORDER_RADIUS_SMALL}px;
        font-size: 15px;
        height: 40px;
        margin: 0;
        padding: 0 12px;
    }
`
